export enum BRIDGE_SHARE_TYPE {
  ROOM = 1,
  PRODUCT = 2,
  PROFILE = 3,
}
